<template>
  <scroll-right-frame>
    <div class="demo-chart1">
      <div id="test-ec-1" class="my-echarts"></div>
      <div id="test-ec-2" class="my-echarts"></div>
      <div id="test-ec-3" class="my-echarts"></div>
      <div id="test-ec-4" class="my-echarts"></div>
      <div id="test-ec-5" class="my-echarts"></div>
      <div id="test-ec-6" class="my-echarts"></div>
      <whaty-chart :chartCode="'demo-chart-01'"></whaty-chart>
    </div>
  </scroll-right-frame>
</template>
<script>
  import echarts from 'echarts'
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import WhatyChart from '../../../../components/whaty-charts/whaty-chart'

  export default {
    name: 'demo-chart1',
    components: {WhatyChart, ScrollRightFrame},
    data() {
      return {}
    },
    created() {
    },
    mounted() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('test-ec-1'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: 'ECharts 入门示例'
        },
        tooltip: {},
        xAxis: {
          data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
        },
        yAxis: {},
        series: [{
          name: '销量',
          type: 'bar',
          data: [5, 20, 36, 10, 10, 20]
        }]
      })
      let myChart2 = echarts.init(document.getElementById('test-ec-2'))
      myChart2.setOption({
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            data: [
              {value: 235, name: '视频广告'},
              {value: 274, name: '联盟广告'},
              {value: 310, name: '邮件营销'},
              {value: 335, name: '直接访问'},
              {value: 400, name: '搜索引擎'}
            ]
          }
        ]
      })
      let myChart3 = echarts.init(document.getElementById('test-ec-3'))
      myChart3.setOption({
        legend: {},
        tooltip: {},
        dataset: {
          // 提供一份数据。
          source: [
            ['product', '2015', '2016', '2017'],
            ['Matcha Latte', 43.3, 85.8, 93.7],
            ['Milk Tea', 83.1, 73.4, 55.1],
            ['Cheese Cocoa', 86.4, 65.2, 82.5],
            ['Walnut Brownie', 72.4, 53.9, 39.1]
          ]
        },
        // 声明一个 X 轴，类目轴（category）。默认情况下，类目轴对应到 dataset 第一列。
        xAxis: {type: 'category'},
        // 声明一个 Y 轴，数值轴。
        yAxis: {},
        // 声明多个 bar 系列，默认情况下，每个系列会自动对应到 dataset 的每一列。
        series: [
          {type: 'bar'},
          {type: 'bar'},
          {type: 'bar'}
        ]
      })
      let myChart4 = echarts.init(document.getElementById('test-ec-4'))
      myChart4.setOption({
        legend: {},
        tooltip: {},
        dataset: {
          // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
          // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
          dimensions: ['product', '2015', '2016', '2017'],
          source: [
            {product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7},
            {product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1},
            {product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5},
            {product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1}
          ]
        },
        xAxis: {type: 'category'},
        yAxis: {},
        series: [
          {type: 'bar'},
          {type: 'bar'},
          {type: 'bar'}
        ]
      })
      let myChart5 = echarts.init(document.getElementById('test-ec-5'))
      myChart5.setOption({
        dataset: {
          source: [
            ['score', 'amount', 'product'],
            [89.3, 58212, 'Matcha Latte'],
            [57.1, 78254, 'Milk Tea'],
            [74.4, 41032, 'Cheese Cocoa'],
            [50.1, 12755, 'Cheese Brownie'],
            [89.7, 20145, 'Matcha Cocoa'],
            [68.1, 79146, 'Tea'],
            [19.6, 91852, 'Orange Juice'],
            [10.6, 101852, 'Lemon Juice'],
            [32.7, 20112, 'Walnut Brownie']
          ]
        },
        xAxis: {},
        yAxis: {type: 'category'},
        series: [
          {
            type: 'bar',
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: 'amount',
              // 将 "product" 列映射到 Y 轴。
              y: 'product'
            }
          }
        ]
      })
      // init chart
      let myChart6 = echarts.init(document.getElementById('test-ec-6'))
      myChart6.setOption({
        legend: {},
        tooltip: {trigger: 'axis'},
        dataset: {
          sourceHeader: false,
          // 提供一份数据。
          source: [
            {grade: '2012级', yjf: 982, tf: 1, qf: 970, attr4: 1954},
            {grade: '2014级', yjf: 10825, tf: 0, qf: 10862, attr4: 21687},
            {grade: '2015级', yjf: 12413, tf: 0, qf: 12388, attr4: 24801},
            {grade: '2016级', yjf: 166, tf: 0, qf: 160, attr4: 326},
            {grade: '2017级', yjf: 26, tf: 8, qf: 317, attr4: 359},
            {grade: '2018级', yjf: 68, tf: 3, qf: 398, attr4: 472}
          ]
        },
        // 声明一个 X 轴，类目轴（category）。默认情况下，类目轴对应到 dataset 第一列。
        xAxis: {type: 'category', name: '年级'},
        // 声明一个 Y 轴，数值轴。
        yAxis: {type: 'value', name: '人数'},
        // 声明多个 bar 系列，默认情况下，每个系列会自动对应到 dataset 的每一列。
        series: [
          // {type: 'bar', name: '已交费人数'},
          // {type: 'bar', name: '退费人数'},
          // {type: 'bar', name: '欠费人数'},
          // {type: 'bar', name: '总计'}
          {
            type: 'bar',
            name: '已交费人数',
            encode: {
              x: 0,
              y: 1
            }
          },
          {
            type: 'bar',
            name: '退费人数',
            encode: {
              x: 0,
              y: 2
            }
          },
          {
            type: 'bar',
            name: '欠费人数',
            encode: {
              x: 0,
              y: 3
            }
          },
          {
            type: 'bar',
            name: '总计',
            encode: {
              x: 0,
              y: 4
            }
          }
        ]
      })
    }
  }
</script>
<style lang="scss">
  .demo-chart1 {
    .my-echarts {
      width: 400px;
      height: 300px;
      float: left;
      margin: 10px;
      border: 1px solid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/demo/chart/demo-chart1.vue